import React from 'react';

export default function SortDropdown({ C, value, onChange, options }) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)} style={{
      background: C.input,
      border: `1px solid ${C.border}`,
      borderRadius: 10,
      padding: '6px 10px',
      color: C.text,
      fontSize: 11,
      fontWeight: 600,
      cursor: 'pointer',
      outline: 'none',
    }}>
      {options.map(opt => (
        <option key={opt.value} value={opt.value} style={{background: C.bg, color: C.text}}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}

// Common sort presets — apply to an array of items, return new sorted array
export function applySort(items, sortKey) {
  if (!Array.isArray(items)) return items;
  const arr = [...items];
  switch (sortKey) {
    case 'newest':
      return arr.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    case 'oldest':
      return arr.sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0));
    case 'price_low':
      return arr.sort((a, b) => (Number(a.price) || Number(a.starting_price) || Number(a.price_txc) || Number(a.daily_rate) || 0) - (Number(b.price) || Number(b.starting_price) || Number(b.price_txc) || Number(b.daily_rate) || 0));
    case 'price_high':
      return arr.sort((a, b) => (Number(b.price) || Number(b.starting_price) || Number(b.price_txc) || Number(b.daily_rate) || 0) - (Number(a.price) || Number(a.starting_price) || Number(a.price_txc) || Number(a.daily_rate) || 0));
    case 'salary_high':
      return arr.sort((a, b) => (Number(b.salary_max_txc) || Number(b.salary_min_txc) || 0) - (Number(a.salary_max_txc) || Number(a.salary_min_txc) || 0));
    case 'ending_soon':
      return arr.sort((a, b) => new Date(a.end_at || 0) - new Date(b.end_at || 0));
    default:
      return arr;
  }
}
